import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { NotificationService } from 'src/app/services/notification.service';
import { PracticeService } from 'src/app/services/practice.service';

@Component({
  selector: 'app-add-programme',
  templateUrl: './add-programme.component.html',
  styleUrls: ['./add-programme.component.scss']
})
export class AddProgrammeComponent implements OnInit {
  public programmeName:string;

  constructor(
    public dialogRef: MatDialogRef<any>,
    @Inject(MAT_DIALOG_DATA) public data:any,
    private _notify: NotificationService,
    private _practice: PracticeService
  ) { }

  submit() {
    if (this.programmeName){
      this._practice.createPracticeProgramme(this.data.practice.id, this.programmeName).subscribe(
        res=>{
          this._notify.showMessage('New programme created.', 'OK');
          this.dialogRef.close(true);
        }
      );
    } else {
      this._notify.showMessage('Please enter a name for the programme.', 'OK');
    }
  }

  cancel(){
    this.programmeName='';
    this.dialogRef.close(false);
  }

  ngOnInit() {
  }

}
